/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.guestHomepage = (await import('./pages/guest-homepage/GuestHomepageContainer')).GuestHomepageContainer;
    Components.consumerHomepage = (await import('./pages/consumer-homepage/ConsumerHomepageContainer')).ConsumerHomepageContainer;
    Components.proHomepage = (await import('./pages/pro-homepage/ProHomepageContainer')).ProHomepageContainer;
    Components.eprocurementHomepage = (await import('./pages/eprocurement-homepage/EProcurementHomepageContainer')).EProcurementHomepageContainer;
    Components.exchangeHomepage = (await import('./pages/exchange-homepage/ExchangeHomepageContainer')).ExchangeHomepageContainer;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  guestHomepage: {
    name: 'GuestHomepageContainer',
    componentName: 'GuestHomepageContainer',
    chunk: () => import('./pages/guest-homepage/GuestHomepageContainer'),
    get component() {
      return ssr
        ? serverPages.guestHomepage
        : currentRouteName === 'GuestHomepageContainer'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.GuestHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  consumerHomepage: {
    name: 'ConsumerHomepageContainer',
    componentName: 'ConsumerHomepageContainer',
    chunk: () => import('./pages/consumer-homepage/ConsumerHomepageContainer'),
    get component() {
      return ssr
        ? serverPages.consumerHomepage
        : currentRouteName === 'ConsumerHomepageContainer'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ConsumerHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  proHomepage: {
    name: 'ProHomepageContainer',
    componentName: 'ProHomepageContainer',
    chunk: () => import('./pages/pro-homepage/ProHomepageContainer'),
    get component() {
      return ssr
        ? serverPages.proHomepage
        : currentRouteName === 'ProHomepageContainer'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ProHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  eprocurementHomepage: {
    name: 'EProcurementHomepageContainer',
    componentName: 'EProcurementHomepageContainer',
    chunk: () => import('./pages/eprocurement-homepage/EProcurementHomepageContainer'),
    get component() {
      return ssr
        ? serverPages.eprocurementHomepage
        : currentRouteName === 'EProcurementHomepageContainer'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.EProcurementHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  },
  exchangeHomepage: {
    name: 'ExchangeHomepageContainer',
    componentName: 'ExchangeHomepageContainer',
    chunk: () => import('./pages/exchange-homepage/ExchangeHomepageContainer'),
    get component() {
      return ssr
        ? serverPages.exchangeHomepage
        : currentRouteName === 'ExchangeHomepageContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.ExchangeHomepageContainer,
            }))
          );
    },
    path: '/:context?/:contentPv?/:homepagePV?/*',
    varnish: true,
    channel: null,
  }
});
